/*
 * Module for FAS Formulas edit
 */
rs.module("content/system/configuration/fasformulas/edit",

    [
        "common/select-helper",
        "controls/components/event-banner"
    ],

    function (selectHelper, eventBanner) {

        var _executeSelectionChanged;

        // initialize the module
        function initialize(jsSelectors, codeValues, columnIds, grid, ajaxUrl) {

            // This page either has two edit forms (paramsForm and detailsForm) or one addForm containing the same content
            var addForm = $.js(jsSelectors.addForm, { required: false });
            var detailsForm = $.js(jsSelectors.detailsForm, { required: false });

            var fasFormulaKey = detailsForm.length > 0 ? detailsForm.js(jsSelectors.fasFormulaKey) : addForm.js(jsSelectors.fasFormulaKey);
            var routineType = detailsForm.length > 0 ? detailsForm.js(jsSelectors.routineType) : addForm.js(jsSelectors.routineType);
            var routineTypeSelectHelper = selectHelper.getHelper(routineType);
            var effectiveDate = detailsForm.length > 0 ? detailsForm.js(jsSelectors.effectiveDate) : addForm.js(jsSelectors.effectiveDate);
            var terminationDate = detailsForm.length > 0 ? detailsForm.js(jsSelectors.terminationDate) : addForm.js(jsSelectors.terminationDate);
            var timePeriodBasis = detailsForm.length > 0 ? detailsForm.js(jsSelectors.timePeriodBasis) : addForm.js(jsSelectors.timePeriodBasis);
            var timePeriodBasisSelectHelper = selectHelper.getHelper(timePeriodBasis);
            var timePeriodAmount = detailsForm.length > 0 ? detailsForm.js(jsSelectors.timePeriodAmount) : addForm.js(jsSelectors.timePeriodAmount);
            var timePeriodDuration = detailsForm.length > 0 ? detailsForm.js(jsSelectors.timePeriodDuration) : addForm.js(jsSelectors.timePeriodDuration);
            var timePeriodDurationSelectHelper = selectHelper.getHelper(timePeriodDuration);
            var salaryHistoryExamined = detailsForm.length > 0 ? detailsForm.js(jsSelectors.salaryHistoryExamined) : addForm.js(jsSelectors.salaryHistoryExamined);
            var salaryHistoryExaminedSelectHelper = selectHelper.getHelper(salaryHistoryExamined);
            var salaryHistoryAmount = detailsForm.length > 0 ? detailsForm.js(jsSelectors.salaryHistoryAmount) : addForm.js(jsSelectors.salaryHistoryAmount);
            var salaryHistoryDuration = detailsForm.length > 0 ? detailsForm.js(jsSelectors.salaryHistoryDuration) : addForm.js(jsSelectors.salaryHistoryDuration);
            var salaryHistoryDurationSelectHelper = selectHelper.getHelper(salaryHistoryDuration);
            var iterationBasis = detailsForm.length > 0 ? detailsForm.js(jsSelectors.iterationBasis) : addForm.js(jsSelectors.iterationBasis);
            var iterationBasisSelectHelper = selectHelper.getHelper(iterationBasis);
            var timePeriodCalc = detailsForm.length > 0 ? detailsForm.js(jsSelectors.timePeriodCalc) : addForm.js(jsSelectors.timePeriodCalc);
            var timePeriodCalcSelectHelper = selectHelper.getHelper(timePeriodCalc);
            var accrualTargetAmount = detailsForm.length > 0 ? detailsForm.js(jsSelectors.accrualTargetAmount) : addForm.js(jsSelectors.accrualTargetAmount);
            var accrualTargetDuration = detailsForm.length > 0 ? detailsForm.js(jsSelectors.accrualTargetDuration) : addForm.js(jsSelectors.accrualTargetDuration);
            var accrualTargetDurationSelectHelper = selectHelper.getHelper(accrualTargetDuration);
            var detailUpdateToken = detailsForm.length > 0 ? detailsForm.js(jsSelectors.detailUpdateToken) : addForm.js(jsSelectors.detailUpdateToken);

            // these two controls only exist in edit mode
            var addDetailLink = detailsForm.js(jsSelectors.addDetailLink, { required: false });
            var cancelDetailButton = detailsForm.js(jsSelectors.cancelDetailButton, { required: false });

            // register change events
            routineType.change(setDisabledFields);
            salaryHistoryExamined.change(setSalaryDisabledFields);
            timePeriodCalc.change(setAccrualDisabledFields);

            // enable/disable all fields according to current values
            function setDisabledFields() {
                setRoutineDisabledFields();
                setSalaryDisabledFields();
                setAccrualDisabledFields();
            }

            // enable/disable fields according to selected FAS Routine type
            function setRoutineDisabledFields() {
                if (!routineType.val() || routineType.val() == codeValues.averageCode || routineType.val() == codeValues.userEnteredCode) {
                    timePeriodBasisSelectHelper.setDisabled(true).setValue(null);
                    timePeriodAmount.prop('disabled', true).val('');
                    timePeriodDurationSelectHelper.setDisabled(true).setValue(null);
                    salaryHistoryExaminedSelectHelper.setDisabled(true).setValue(null);
                    salaryHistoryAmount.prop('disabled', true).val('');
                    salaryHistoryDurationSelectHelper.setDisabled(true).setValue(null);
                    iterationBasisSelectHelper.setDisabled(true).setValue(null);
                    timePeriodCalcSelectHelper.setDisabled(true).setValue(null);
                    accrualTargetAmount.prop('disabled', true).val('');
                    accrualTargetDurationSelectHelper.setDisabled(true).setValue(null);
                }
                else if (routineType.val() == codeValues.highCode) {
                    timePeriodBasisSelectHelper.setDisabled(false);
                    timePeriodAmount.prop('disabled', false);
                    timePeriodDurationSelectHelper.setDisabled(false);
                    salaryHistoryExaminedSelectHelper.setDisabled(false);
                    salaryHistoryAmount.prop('disabled', false);
                    salaryHistoryDurationSelectHelper.setDisabled(false);
                    iterationBasisSelectHelper.setDisabled(false);
                    timePeriodCalcSelectHelper.setDisabled(false);
                    accrualTargetAmount.prop('disabled', false);
                    accrualTargetDurationSelectHelper.setDisabled(false);
                }
                else if (routineType.val() == codeValues.lastCode) {
                    timePeriodBasisSelectHelper.setDisabled(true).setValue(null);
                    timePeriodAmount.prop('disabled', false);
                    timePeriodDurationSelectHelper.setDisabled(false);
                    salaryHistoryExaminedSelectHelper.setDisabled(true).setValue(null);
                    salaryHistoryAmount.prop('disabled', true).val('');
                    salaryHistoryDurationSelectHelper.setDisabled(true).setValue(null);
                    iterationBasisSelectHelper.setDisabled(true).setValue(null);
                    timePeriodCalcSelectHelper.setDisabled(false);
                    accrualTargetAmount.prop('disabled', false);
                    accrualTargetDurationSelectHelper.setDisabled(false);
                }
            }

            // enable/disable fields according to selected Salary History Examined value
            function setSalaryDisabledFields() {
                if (!salaryHistoryExamined.val() || salaryHistoryExamined.val() == codeValues.allSalaryCode) {
                    salaryHistoryAmount.prop('disabled', true).val('');
                    salaryHistoryDurationSelectHelper.setDisabled(true).setValue(null);
                }
                else if (salaryHistoryExamined.val() == codeValues.lastSalaryCode) {
                    salaryHistoryAmount.prop('disabled', false);
                    salaryHistoryDurationSelectHelper.setDisabled(false);
                }
            }

            // enable/disable fields according to selected Time Period Calc value
            function setAccrualDisabledFields() {
                if (!timePeriodCalc.val() || timePeriodCalc.val() == codeValues.calendarCode) {
                    accrualTargetAmount.prop('disabled', true).val('');
                    accrualTargetDurationSelectHelper.setDisabled(true).setValue(null);
                }
                else if (timePeriodCalc.val() == codeValues.accrualCode) {
                    accrualTargetAmount.prop('disabled', false);
                    accrualTargetDurationSelectHelper.setDisabled(false);
                }
            }

            if (grid) {
                addDetailLink.on("click", addDetailClicked);
                cancelDetailButton.on("click", cancelDetailClicked);

                grid.selectionChanged(function (values, rows) {

                    // This handler fires when the grid is first rendered, but we don't want it to in our case
                    // _executeSelectionChanged will be false the first time it runs, after that this will fire every time a row is clicked
                    if (_executeSelectionChanged && values.length > 0) {
                        eventBanner.removeAllMessages();

                        $.get(
                            ajaxUrl,
                            { fasFormulaKey: rows[0][columnIds.fasFormulaKey] },

                            function (data) {

                                // clear existing field-level errors
                                clearAllErrors();

                                // set field values from ajax result
                                routineTypeSelectHelper.setValue(data.routineType);
                                effectiveDate.val(data.effectiveDate ? new Date(data.effectiveDate).toISODateString() : null);
                                terminationDate.val(data.terminationDate ? new Date(data.terminationDate).toISODateString() : null);
                                timePeriodBasisSelectHelper.setValue(data.timePeriodBasis);
                                timePeriodAmount.val(data.timePeriodAmount);
                                timePeriodDurationSelectHelper.setValue(data.timePeriodDuration);
                                salaryHistoryExaminedSelectHelper.setValue(data.salaryHistoryExamined);
                                salaryHistoryAmount.val(data.salaryHistoryAmount);
                                salaryHistoryDurationSelectHelper.setValue(data.salaryHistoryDuration);
                                iterationBasisSelectHelper.setValue(data.iterationBasis);
                                timePeriodCalcSelectHelper.setValue(data.timePeriodCalc);
                                accrualTargetAmount.val(data.accrualTargetAmount);
                                accrualTargetDurationSelectHelper.setValue(data.accrualTargetDuration);
                                fasFormulaKey.val(data.fasFormulaKey);
                                detailUpdateToken.val(data.updateToken);

                                // enable/disable fields accordingly
                                setDisabledFields();
                            }
                        );
                    }

                    _executeSelectionChanged = true;
                });

                // clear event banner messages, grid selection, errors, and values when the add detail button is clicked
                function addDetailClicked() {
                    eventBanner.removeAllMessages();

                    grid.selectedValues = null;

                    // reset form
                    clearAllErrors();
                    routineTypeSelectHelper.setValue(null);
                    effectiveDate.val('');
                    terminationDate.val('');
                    timePeriodBasisSelectHelper.setValue(null);
                    timePeriodAmount.val('');
                    timePeriodDurationSelectHelper.setValue(null);
                    salaryHistoryExaminedSelectHelper.setValue(null);
                    salaryHistoryAmount.val('');
                    salaryHistoryDurationSelectHelper.setValue(null);
                    iterationBasisSelectHelper.setValue(null);
                    timePeriodCalcSelectHelper.setValue(null);
                    accrualTargetAmount.val('');
                    accrualTargetDurationSelectHelper.setValue(null);
                    fasFormulaKey.val(-1);
                    detailUpdateToken.val('');

                    // enable/disable fields accordingly
                    setDisabledFields();
                }

                // clear event banner messages and reset grid selection to first row
                function cancelDetailClicked() {
                    eventBanner.removeAllMessages();

                    // reset form
                    clearAllErrors();
                    routineTypeSelectHelper.setValue(null);
                    effectiveDate.val('');
                    terminationDate.val('');
                    timePeriodBasisSelectHelper.setValue(null);
                    timePeriodAmount.val('');
                    timePeriodDurationSelectHelper.setValue(null);
                    salaryHistoryExaminedSelectHelper.setValue(null);
                    salaryHistoryAmount.val('');
                    salaryHistoryDurationSelectHelper.setValue(null);
                    iterationBasisSelectHelper.setValue(null);
                    timePeriodCalcSelectHelper.setValue(null);
                    accrualTargetAmount.val('');
                    accrualTargetDurationSelectHelper.setValue(null);
                    fasFormulaKey.val(-1);
                    detailUpdateToken.val('');

                    grid.selectedValues = null;
                    grid.selectFirstRow();
                }

                // helper method to clear field validation errors for all fields
                function clearAllErrors() {
                    routineType.clearErrors();
                    effectiveDate.clearErrors();
                    terminationDate.clearErrors();
                    timePeriodBasis.clearErrors();
                    timePeriodAmount.clearErrors();
                    timePeriodDuration.clearErrors();
                    salaryHistoryExamined.clearErrors();
                    salaryHistoryAmount.clearErrors();
                    salaryHistoryDuration.clearErrors();
                    iterationBasis.clearErrors();
                    timePeriodCalc.clearErrors();
                    accrualTargetAmount.clearErrors();
                    accrualTargetDuration.clearErrors();
                }
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);